import { PricingMatrix } from '../types/Pricing';

export const PRICING_MATRIX: PricingMatrix[] = [
  {
    order: 1,
    title: 'Essential',
    features: ['50000 requests per month', '3 seats'],
    currency: 'USD',
    pricing: {
      monthly: {
        pricePerMonth: 19,
        priceId: process.env['REACT_APP_PRICE_ID_ESSENTIAL_M']!,
      },
      annualy: {
        pricePerMonth: 16,
        priceId: process.env['REACT_APP_PRICE_ID_ESSENTIAL_A']!,
      },
    },
    promoted: false,
  },
  {
    order: 2,
    title: 'Pro',
    features: ['150000 requests per month', '8 seats'],
    currency: 'USD',
    pricing: {
      monthly: {
        pricePerMonth: 39,
        priceId: process.env['REACT_APP_PRICE_ID_PRO_M']!,
      },
      annualy: {
        pricePerMonth: 33,
        priceId: process.env['REACT_APP_PRICE_ID_PRO_A']!,
      },
    },
    promoted: true,
  },
  {
    order: 3,
    title: 'Scale',
    features: ['500000 requests per month', '15 seats'],
    currency: 'USD',
    pricing: {
      monthly: {
        pricePerMonth: 79,
        priceId: process.env['REACT_APP_PRICE_ID_SCALE_M']!,
      },
      annualy: {
        pricePerMonth: 66,
        priceId: process.env['REACT_APP_PRICE_ID_SCALE_A']!,
      },
    },
    promoted: false,
  },
];
